import React, { useMemo, useState } from 'react';
import InfoModal from '../components/common/InfoModal';
import ErrorModal from '../components/common/ErrorModal';
import ConfirmModal from '../components/common/ConfirmModal';

export const MessagingContext = React.createContext();

export const useMessaging = () => React.useContext(MessagingContext);

export function MessagingProvider({ children }) {
  const [infoMessage, setInfoMessage] = useState();
  const [confirmMessage, setConfirmMessage] = useState();
  const [errorMessage, setErrorMessage] = useState();
  const value = useMemo(
    () => ({
      setInfoMessage,
      setErrorMessage,
      setConfirmMessage,
    }),
    []
  );

  return (
    <MessagingContext.Provider value={value}>
      {!!confirmMessage && (
        <ConfirmModal
          hide={() => setConfirmMessage(undefined)}
          titleAlert={confirmMessage.titleAlert}
          confirm1={confirmMessage.confirm1}
          confirm2={confirmMessage.confirm2}
          onConfirm={confirmMessage.onConfirm}
          onCancel={confirmMessage.onCancel}
        />
      )}
      {!!infoMessage && (
        <InfoModal
          onclick={() => {
            setInfoMessage(undefined);
          }}
          titleAlert={infoMessage.titleAlert}
          info1={infoMessage.info1}
          info2={infoMessage.info2}
        />
      )}
      {!!errorMessage && (
        <ErrorModal
          onclick={() => {
            setErrorMessage(undefined);
          }}
          titleAlert={errorMessage.titleAlert}
          info1={errorMessage.info1}
          info2={errorMessage.info2}
          error={errorMessage.error}
        />
      )}
      {children}
    </MessagingContext.Provider>
  );
}
